export default __webpack_public_path__ + "static/media/CustoImage (8).47b33768.png";